// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WVmAy","colMin":"styles_colMin__1q19_"};